import '../containers/App.css';
import 'tachyons';

function Start()
{
	return(
	       <div>
		       <div class="heading_box mt2"><h2 class="abril ">Legendary Songs</h2></div>
				<br/>
				<p class="playfair arial">Welcome to my playlist. Here we have some legendary songs and if you listen these you will realize what true songs are.</p>
				<br/>
			</div>
       );
}

export default Start;